module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "instrument"
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('div', [_c('label', [_vm._v("Steps: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.steps),
      expression: "steps",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.steps)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.steps = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('div', [_c('label', [_vm._v("Measures: ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.measures),
      expression: "measures",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.measures)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.measures = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('div', [_c('label', [_vm._v("Transpose (semitones): ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.transpose),
      expression: "transpose",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.transpose)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.transpose = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('div', [_c('label', [_vm._v("Velocity (%): ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.volume),
      expression: "volume",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.volume)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.volume = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('div', [_c('label', [_vm._v("Synth type: ")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.synth),
      expression: "synth"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.synth = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "disabled"
    }
  }), _c('option', [_vm._v("sine")]), _c('option', [_vm._v("sawtooth")]), _c('option', [_vm._v("square")]), _c('option', [_vm._v("triangle")]), _c('option', {
    attrs: {
      "disabled": "disabled"
    }
  }), _c('option', [_vm._v("sine4")]), _c('option', [_vm._v("sawtooth4")]), _c('option', [_vm._v("square4")]), _c('option', [_vm._v("triangle4")]), _c('option', {
    attrs: {
      "disabled": "disabled"
    }
  }), _c('option', [_vm._v("fmsine")]), _c('option', [_vm._v("fmsawtooth")]), _c('option', [_vm._v("fmsquare")]), _c('option', [_vm._v("fmtriangle")]), _c('option', {
    attrs: {
      "disabled": "disabled"
    }
  }), _c('option', [_vm._v("fatsine")]), _c('option', [_vm._v("fatsawtooth")]), _c('option', [_vm._v("fatsquare")]), _c('option', [_vm._v("fattriangle")])])]), _c('div', [_c('label', [_vm._v("Attack (seconds): ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.attack),
      expression: "attack",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.attack)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.attack = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('div', [_c('label', [_vm._v("Decay (seconds): ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.decay),
      expression: "decay",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.decay)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.decay = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('div', [_c('label', [_vm._v("Filter cutoff (hz): ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.filterCutoff),
      expression: "filterCutoff",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filterCutoff)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterCutoff = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _c('div', {
    staticClass: "boxes"
  }, _vm._l((_vm.notes), function(onNotes, pitch) {
    return _c('line-c', {
      attrs: {
        "beats": _vm.steps,
        "current-note": _vm.currentStep,
        "pitch": pitch,
        "on-notes": onNotes
      },
      on: {
        "toggle-box": _vm.handleToggleBox
      }
    })
  }))]), _c('hr')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6fc3f304!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Instrument.vue
// module id = 20
// module chunks = 1